import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useOnCloseTeamView = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return () => {
    navigate(navigation.calendar.teamView.fullPath())
  }
}
